import { createRoot } from 'react-dom/client'
// Axios
import { Chart, registerables } from 'chart.js'
import { QueryClient, QueryClientProvider } from 'react-query'

// Apps
import { MetronicI18nProvider } from './_metronic/i18n/Metronici18n'
/**
 * TIP: Replace this style import with rtl styles to enable rtl mode
 *
 * import './_metronic/assets/css/style.rtl.css'
 **/
import '_metronic/assets/sass/style.scss'
import '_metronic/assets/sass/plugins.scss'
import '_metronic/assets/sass/style.react.scss'
import { AppRoutes } from 'app/routing/AppRoutes'
import { AuthProvider } from 'Presentation/Views/Auth/core/Auth'

import { ToastContainer } from 'react-toastify'

// DHealth˝ Styles and Customized Components Styles
import './Styles/main.scss'

import AppContext from 'Context'

import axios from 'axios'
import { setupAxios } from 'Configuration/Axios'

// Library Styles
import 'react-tooltip/dist/react-tooltip.css'
import 'react-datetime/css/react-datetime.css'
import 'react-toastify/dist/ReactToastify.css'
import 'leaflet/dist/leaflet.css'

setupAxios(axios)

/**
 * Creates `axios-mock-adapter` instance for provided `axios` instance, add
 * basic Metronic mocks and returns it.
 *
 * @see https://github.com/ctimmerm/axios-mock-adapter
 */
/**
 * Inject Metronic interceptors for axios.
 *
 * @see https://github.com/axios/axios#interceptors
 */

Chart.register(...registerables)

const queryClient = new QueryClient()
const container = document.getElementById('root')
if (container) {
  createRoot(container).render(
    <QueryClientProvider client={queryClient}>
      <MetronicI18nProvider>
        <AuthProvider>
          <AppContext>
            <AppRoutes />

            <ToastContainer />
          </AppContext>
        </AuthProvider>
      </MetronicI18nProvider>
    </QueryClientProvider>
  )
}
